// jQueryプラグイン
import anime from 'animejs/lib/anime.es.js';
import gsap from 'gsap';

export function companyFunc() {
  let companyTop = $('#companyTop').length;
  let companyNumbers = $('#companyNumbers').length;

  let resizecheck = $('#responsibleCheck').width();

  $(window).on('resize', function () {
    resizecheck = $('#responsibleCheck').width();
  });

  if(companyTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));
    
    function txtParaRight(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((elemO - winScroll) / 14) + 'px)');
        }
      });
    }
    function txtParaLeft(elm) {
      let winScroll = $(window).scrollTop();
      var windowH = window.innerHeight;
      var elm = $(elm);
      elm.each(function () {
        var elemO = elm.offset().top;
        var elemH = elm.height();

        if(winScroll > elemO - windowH && winScroll < elemO + elemH){
          elm.css('transform', 'translateX(' + ((winScroll - elemO) / 14) + 'px)');
        }
      });
    }

    function companyCommonAnimeFunc() {
      $('.pageEntrance').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 200) {
          wait(0)
          .then(() => {
            if (!$(this).find('.imgBox').hasClass('isShow')) {
              $(this).find('.imgBox').addClass('isShow');
            }
            return wait(500)
          })
          .then(() => {
              if (!$(this).find('.pageEntranceTit').hasClass('isShow')) {
                $(this).find('.pageEntranceTit').addClass('isShow');
                $(this).find('.btn01').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }

    companyCommonAnimeFunc();
    txtParaRight('.companyDecoTxt');
    txtParaRight('.numbersDecoTxt');
    txtParaRight('.historyDecoTxt');
    txtParaRight('.snsDecoTxt');

    $(window).on('load scroll', function () {
      txtParaRight('.companyDecoTxt');
      txtParaRight('.numbersDecoTxt');
      txtParaRight('.historyDecoTxt');
      txtParaRight('.snsDecoTxt');

      companyCommonAnimeFunc();
    });
  }

  if(companyNumbers){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms));

    let graphAnimationFlag01 = false;
    let graphAnimationFlag02 = false;
    let graphAnimationFlag03 = false;
    let graphAnimationFlag04 = false;
    let graphAnimationFlag05 = false;
    let graphAnimationFlag06 = false;
    let graphAnimationFlag07 = false;
    let graphAnimationFlag08 = false;
    let graphAnimationFlag09 = false;
    let graphAnimationFlag10 = false;
    let graphAnimationFlag11 = false;
    let graphAnimationFlag12 = false;
    let graphAnimationFlag13 = false;

    let scrHightNum;

    function numbersAreaFunc(){
      if (resizecheck == '2') {
        scrHightNum = 0;
      } else if (resizecheck == '1') {
        scrHightNum = 200;
      }

      $('.number01').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number01 .num01');
        let roundDateLogEl02 = document.querySelector('.number01 .num02');
        let roundDateLogEl03 = document.querySelector('.number01 .num03');
        let roundDateLogEl04 = document.querySelector('.number01 .num04');

        // 数字→アルファベット変換
        function convertToMonthName(monthNum) {
          const months = [
              'July', 'August', 'March', 'April', 'May', 'June',
              'July', 'August', 'March', 'April', 'May', 'June'
          ];
      
          // 月番号が1〜12の範囲内かチェック
          if (monthNum >= 1 && monthNum <= 12) {
              return months[monthNum - 1];
          }
        }
      
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag01) {
            graphAnimationFlag01 = true;

            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 2005],
                easing: 'easeInOutExpo',
                duration: 700,
                round: 1, // Will round the animated value to 1 decimal
                complete: ()=> {
                  $('.number01').find('.linkTxt01').addClass('isShow');
                }
              });
              anime({
                targets: roundDateLogEl02,
                innerHTML: [0, 2025],
                easing: 'easeInOutExpo',
                duration: 700,
                round: 1, // Will round the animated value to 1 decimal
              });
              anime({
                targets: roundDateLogEl03,
                innerHTML: [4, 5, 6, 7, 8, 9 ,10, 11, 12, 1, 2, 3],
                easing: 'easeInOutExpo',
                duration: 700,
                round: 1, // Will round the animated value to 1 decimal,
                change: function() {
                  const tmonthsTxt = convertToMonthName(roundDateLogEl03.innerHTML);
                  roundDateLogEl04.innerHTML = tmonthsTxt;
                  //roundDateLogEl03.innerHTML = JSON.stringify(myObject);
                },
                changeComplete: function(anim) {
                  roundDateLogEl04.innerHTML = 'March';
                }
              });
              $(this).find('.svg01').addClass('isShow');
              // return wait(400)
            })
            .then(() => {
              $(this).find('.svg02').addClass('isShow');
              // return wait(400)
            })
            .then(() => {
              $(this).find('.svg03').addClass('isShow');
              return wait(500)
            })
          }
          
        }
      });

      $('.number02').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number02 .num');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag02) {
            graphAnimationFlag02 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 238],
                easing: 'easeInOutExpo',
                duration: 1000,
                round: 1, // Will round the animated value to 1 decimal
              });
              return wait(250)
            })
            .then(() => {
              $(this).find('.svg03').addClass('isShow');
              return wait(400)
            })
            .then(() => {
              $(this).find('.svg02').addClass('isShow');
              return wait(400)
            })
            .then(() => {
              $(this).find('.svg01').addClass('isShow');
              return wait(400)
            })
          }
          
        }
      });

      $('.number03').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number03 .num01');
        let roundDateLogEl02 = document.querySelector('.number03 .num02');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag03) {
            graphAnimationFlag03 = true;

            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 42],
                easing: 'easeInOutExpo',
                duration: 1200,
                round: 1, // Will round the animated value to 1 decimal
              });
              anime({
                targets: roundDateLogEl02,
                innerHTML: [0, 58],
                easing: 'easeInOutExpo',
                duration: 1200,
                round: 1, // Will round the animated value to 1 decimal
              });
              return wait(250)
            })
            .then(() => {
              $(this).find('.pie01').addClass('isShow');
              $(this).find('.pie02').addClass('isShow');
              return wait(200)
            })
          }
          
        }
      });

      $('.number04').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number04 .num');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag04) {
            graphAnimationFlag04 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 37],
                easing: 'easeInOutExpo',
                duration: 1000,
                round: 1, // Will round the animated value to 1 decimal
              });
              return wait(400)
            })
            .then(() => {
              $(this).find('.svg01').addClass('isShow');
              return wait(400)
            })
            .then(() => {
              $(this).find('.svg02').addClass('isShow');
              return wait(400)
            })
          }
          
        }
      });

      $('.number05').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number05 .num');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag05) {
            graphAnimationFlag05 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 180],
                easing: 'easeInOutExpo',
                duration: 1000,
                round: 1, // Will round the animated value to 1 decimal
              });
              return wait(400)
            })
            .then(() => {
              $(this).find('.svg01').addClass('isShow');
              return wait(300)
            })
          }
          
        }
      });

      $('.number06').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number06 .num02');
        let roundDateLogEl02 = document.querySelector('.number06 .num03');
        let roundDateLogEl03 = document.querySelector('.number06 .num04');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag06) {
            graphAnimationFlag06 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 162],
                easing: 'easeOutQuad',
                duration: 700,
                delay: 100,
                round: 1, // Will round the animated value to 1 decimal
                update: ()=> {
                  let num = Number(roundDateLogEl01.innerHTML).toLocaleString();
                  roundDateLogEl01.innerHTML = num;
                },
                complete: ()=> {
                  $('.num01').addClass('show');
                  $('.number06').find('.linkTxt01').addClass('isShow');
                }
              });
              // anime({
              //   targets: roundDateLogEl02,
              //   innerHTML: [0, 130],
              //   easing: 'easeOutQuad',
              //   duration: 700,
              //   delay: 500,
              //   round: 1, // Will round the animated value to 1 decimal
              //   complete: ()=> {
              //     $('.num05').addClass('show');
              //   }
              //   // update: ()=> {
              //   //   let num = Number(roundDateLogEl02.innerHTML).toLocaleString();
              //   //   roundDateLogEl02.innerHTML = num;
                  
              //   //   const elem = $('.number06 .num03');
              //   //   const elemTxt = elem.html();
              //   //   const elemTxtNum = elemTxt.length;
              //   //   const targetTxt = elemTxt.slice(0, 2);
              //   //   const txtLength = targetTxt.length;// ターゲットの文字列の長さを取得
              //   //   const searchNum = elemTxt.indexOf(targetTxt);// 何文字目にあるか取得(0~)
              //   //   const firstStr = elemTxt.slice(searchNum+txtLength, elemTxtNum);// これは
              //   //   const targetStr = elemTxt.slice(searchNum, searchNum+txtLength);// テスト
              //   //   // 結合
              //   //   elem.html('<span class="comma">' + targetStr + '</span>' + firstStr);
              //   // },
              // });
              // anime({
              //   targets: roundDateLogEl03,
              //   innerHTML: [0, 3170],
              //   easing: 'easeOutQuad',
              //   duration: 700,
              //   delay: 500,
              //   round: 1, // Will round the animated value to 1 decimal
              //   update: ()=> {
              //     let num = Number(roundDateLogEl03.innerHTML).toLocaleString();
              //     roundDateLogEl03.innerHTML = num;
                  
              //     const elem = $('.number06 .num04');
              //     const elemTxt = elem.html();
              //     const elemTxtNum = elemTxt.length;
              //     const targetTxt = elemTxt.slice(0, 2);
              //     const txtLength = targetTxt.length;// ターゲットの文字列の長さを取得
              //     const searchNum = elemTxt.indexOf(targetTxt);// 何文字目にあるか取得(0~)
              //     const firstStr = elemTxt.slice(searchNum+txtLength, elemTxtNum);// これは
              //     const targetStr = elemTxt.slice(searchNum, searchNum+txtLength);// テスト
              //     // 結合
              //     elem.html('<span class="comma">' + targetStr + '</span>' + firstStr);
              //   },
              // });
              return wait(400)
            })
            .then(() => {
              $(this).find('.svg01').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg02').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg03').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg04').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg05').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg06').addClass('isShow');
              return wait(300)
            })
          }
          
        }
      });

      $('.number07').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number07 .num01');
        let roundDateLogEl02 = document.querySelector('.number07 .num02');
        let roundDateLogEl03 = document.querySelector('.number07 .num03');
        let roundDateLogEl04 = document.querySelector('.number07 .num04');
        let roundDateLogEl05 = document.querySelector('.number07 .num05');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag07) {
            graphAnimationFlag07 = true;
            // var tl = anime.timeline({
            //   easing: 'linear',
            //   duration: 1600,
            //   round: 1, // Will round the animated value to 1 decimal
            // });
            wait(0)
            .then(() => {
              anime({
                begin: function() {
                  $('.graph01').find('.txtBox').addClass('isShow');
                },
                targets: roundDateLogEl01,
                innerHTML: [0, 10],
                duration: 700,
                round: 1,
              });
              anime({
                begin: function() {
                  $('.graph01').find('.upTxt').addClass('isShow');
                },
                targets: roundDateLogEl02,
                innerHTML: [0, 107],
                duration: 700,
                round: 1,
              });
              anime({
                begin: function() {
                  $('.graph02').find('.txtBox').addClass('isShow');
                },
                targets: roundDateLogEl03,
                innerHTML: [0, 10.7],
                duration: 700,
                round: 10,
                complete: function(anim) {
                  $('.graph02').find('.txt').addClass('isColor');
                }
              });
              anime({
                begin: function() {
                  $('.graph02').find('.upTxt').addClass('isShow');
                },
                targets: roundDateLogEl04,
                innerHTML: [0, 108],
                duration: 700,
                round: 1,
              });
              anime({
                begin: function() {
                  $('.graph03').find('.txtBox').addClass('isShow');
                },
                targets: roundDateLogEl05,
                innerHTML: [0, 11.5],
                duration: 700,
                round: 10,
                complete: function(anim) {
                  $('.graph03').find('.txt').addClass('isColor');
                }
              });
            })
            // tl
            // .add({
            //   begin: function() {
            //     $('.graph01').find('.txtBox').addClass('isShow');
            //   },
            //   targets: roundDateLogEl01,
            //   innerHTML: [0, 68],
            //   duration: 700,
            // })
            // .add({
            //   begin: function() {
            //     $('.graph01').find('.upTxt').addClass('isShow');
            //   },
            //   targets: roundDateLogEl02,
            //   innerHTML: [0, 111],
            //   duration: 700,
            // })
            // .add({
            //   begin: function() {
            //     $('.graph02').find('.txtBox').addClass('isShow');
            //   },
            //   targets: roundDateLogEl03,
            //   innerHTML: [0, 76],
            //   duration: 700,
            //   complete: function(anim) {
            //     $('.graph02').find('.txt').addClass('isColor');
            //   }
            // })
            // .add({
            //   begin: function() {
            //     $('.graph02').find('.upTxt').addClass('isShow');
            //   },
            //   targets: roundDateLogEl04,
            //   innerHTML: [0, 119],
            //   duration: 700,
            // })
            // .add({
            //   begin: function() {
            //     $('.graph03').find('.txtBox').addClass('isShow');
            //   },
            //   targets: roundDateLogEl05,
            //   innerHTML: [0, 90],
            //   duration: 700,
            //   complete: function(anim) {
            //     $('.graph03').find('.txt').addClass('isColor');
            //   }
            // })
          }
          
        }
      });

      $('.number08').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number08 .num');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag08) {
            graphAnimationFlag08 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 73],
                easing: 'easeInOutExpo',
                duration: 1000,
                round: 1, // Will round the animated value to 1 decimal,
                complete: ()=> {
                  $('.number08').find('.linkTxt02').addClass('isShow');
                }
              });
              $(this).find('.svg01').addClass('isShow');
              return wait(600)
            })
            .then(() => {
              $(this).find('.svg02').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg03').addClass('isShow');
              return wait(300)
            })
          }
          
        }
      });

      $('.number09').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number09 .num');
        let roundDateLogEl02 = document.querySelector('.number09 .back');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag09) {
            graphAnimationFlag09 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 23938],
                easing: 'easeOutQuad',
                duration: 1000,
                delay: 100,
                round: 1, // Will round the animated value to 1 decimal
                update: ()=> {
                  let num = Number(roundDateLogEl01.innerHTML).toLocaleString();
                  roundDateLogEl01.innerHTML = num;
                }
              });
              anime({
                targets: roundDateLogEl02,
                innerHTML: [0, 23938],
                easing: 'easeOutQuad',
                duration: 1000,
                delay: 100,
                round: 1, // Will round the animated value to 1 decimal
                update: ()=> {
                  let num = Number(roundDateLogEl02.innerHTML).toLocaleString();
                  roundDateLogEl02.innerHTML = num;
                },
                complete: ()=> {
                  $('.number09').find('.linkTxt02').addClass('isShow');
                }
              });
              return wait(250)
            })
            .then(() => {
              $(this).find('.svg01').addClass('isShow');
              $(this).find('.svg02').addClass('isShow');
              return wait(300)
            })
          }
          
        }
      });

      $('.number10').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number10 .num');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag10) {
            graphAnimationFlag10 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 1137],
                easing: 'easeOutQuad',
                duration: 1000,
                delay: 100,
                round: 1, // Will round the animated value to 1 decimal
                update: ()=> {
                  let num = Number(roundDateLogEl01.innerHTML).toLocaleString();
                  roundDateLogEl01.innerHTML = num;
                },
                complete: ()=> {
                  $('.number10').find('.attention').addClass('isShow');
                }
              });
              return wait(400)
            })
            .then(() => {
              $(this).find('.svg01').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg02').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg03').addClass('isShow');
              return wait(300)
            })
            .then(() => {
              $(this).find('.svg04').addClass('isShow');
              return wait(300)
            })
          }
          
        }
      });

      $('.number11').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number11 .num01');
        let roundDateLogEl02 = document.querySelector('.number11 .num02');
        let roundDateLogEl03 = document.querySelector('.number11 .num03');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag11) {
            graphAnimationFlag11 = true;
            var tl = anime.timeline({
              easing: 'linear',
              round: 1, // Will round the animated value to 1 decimal,
            });

            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl02,
                innerHTML: [0, 5],
                duration: 400,
                round: 1,
              });
              anime({
                targets: roundDateLogEl03,
                innerHTML: [0, 5],
                duration: 400,
                round: 1,
              });
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 10],
                duration: 800,
                round: 1,
                complete: ()=> {
                  $('.number11').find('.linkTxt01').addClass('isShow');
                }
              });
              // tl
              // .add({
              //   targets: roundDateLogEl02,
              //   innerHTML: [0, 5],
              //   duration: 400,
              // })
              // .add({
              //   targets: roundDateLogEl03,
              //   innerHTML: [0, 6],
              //   duration: 400,
              // }, '-=400')
              // .add({
              //   targets: roundDateLogEl01,
              //   innerHTML: [0, 11],
              //   duration: 800,
              //   complete: ()=> {
              //     $('.number11').find('.linkTxt01').addClass('isShow');
              //   }
              // }, '+=100')

              $(this).find('.svg01').addClass('isShow');
              // return wait(200)
            })
            .then(() => {
              $(this).find('.svg02').addClass('isShow');
              // return wait(200)
            })
            .then(() => {
              $(this).find('.svg03').addClass('isShow');
              $(this).find('.svg04').addClass('isShow');
              return wait(400)
            })
          }
          
        }
      });

      $('.number12').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number12 .num');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag12) {
            graphAnimationFlag12 = true;
            wait(0)
            .then(() => {
              anime({
                targets: roundDateLogEl01,
                innerHTML: [0, 17],
                easing: 'easeInOutExpo',
                duration: 1500,
                round: 1, // Will round the animated value to 1 decimal,
                complete: ()=> {
                  $('.number12').find('.linkTxt02').addClass('isShow');
                }
              });

              $(this).find('.leftBox').addClass('isShow');
              return wait(800)
            })
            .then(() => {
              $(this).find('.rightBox').addClass('isShow');
              return wait(200)
            })
          }
          
        }
      });

      $('.number13').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();

        let roundDateLogEl01 = document.querySelector('.number13 .num01');
        let roundDateLogEl01Mini = document.querySelector('.number13 .miniNum01');
        let roundDateLogEl02 = document.querySelector('.number13 .num02');
        let roundDateLogEl02Mini = document.querySelector('.number13 .miniNum02');
        let roundDateLogEl03 = document.querySelector('.number13 .num03');
        let roundDateLogEl03Mini = document.querySelector('.number13 .miniNum03');
  
        if (scroll > position - windowHeight + scrHightNum) {
          if (!graphAnimationFlag13) {
            graphAnimationFlag13 = true;
            anime({
              targets: roundDateLogEl01,
              innerHTML: [0, 89],
              duration: 500,
              easing: 'linear',
              round: 1, // Will round the animated value to 1 decimal
              begin: function() {
                $('.box01').find('.img').addClass('isShow');
                $('.box01').find('.fadeTxt').addClass('isShow');
              },
              complete: ()=> {
                $('.updatedDate').addClass('isShow');
              }
              // complete: ()=> {
              //   const elem = $('.number13 .num01');
              //   const elemTxt = elem.html();
              //   const targetTxt = elemTxt.slice(2, 4);
              //   const txtLength = targetTxt.length;// ターゲットの文字列の長さを取得
              //   const searchNum = elemTxt.indexOf(targetTxt);// 何文字目にあるか取得(0~)
              //   const firstStr = elemTxt.slice(0, searchNum);// これは
              //   const targetStr = elemTxt.slice(searchNum, searchNum+txtLength);// テスト
              //   // 結合
              //   elem.html(firstStr + '<span class="mini">' + targetStr + '</span>');
              //   $('.number13').find('.attention').addClass('isShow');
              // }
            });
            anime({
              targets: roundDateLogEl01Mini,
              innerHTML: [0, 5],
              duration: 1000,
              round: 1, // Will round the animated value to 1 decimal
            });
            anime({
              targets: roundDateLogEl02,
              innerHTML: [0, 23],
              duration: 500,
              easing: 'linear',
              round: 1, // Will round the animated value to 1 decimal
              delay:300,
              begin: function() {
                $('.box02').find('.img').addClass('isShow');
                $('.box02').find('.fadeTxt').addClass('isShow');
              },
              // complete: ()=> {
              //   const elem = $('.number13 .num02');
              //   const elemTxt = elem.html();
              //   const targetTxt = elemTxt.slice(2, 4);
              //   const txtLength = targetTxt.length;// ターゲットの文字列の長さを取得
              //   const searchNum = elemTxt.indexOf(targetTxt);// 何文字目にあるか取得(0~)
              //   const firstStr = elemTxt.slice(0, searchNum);// これは
              //   const targetStr = elemTxt.slice(searchNum, searchNum+txtLength);// テスト
              //   // 結合
              //   elem.html(firstStr + '<span class="mini">' + targetStr + '</span>');
              // }
            });
            anime({
              targets: roundDateLogEl02Mini,
              innerHTML: [0, 5],
              duration: 1000,
              delay:300,
              round: 1, // Will round the animated value to 1 decimal
            });
            anime({
              targets: roundDateLogEl03,
              innerHTML: [0, 19],
              duration: 500,
              easing: 'linear',
              round: 1, // Will round the animated value to 1 decimal
              delay:500,
              begin: function() {
                $('.box03').find('.img').addClass('isShow');
                $('.box03').find('.fadeTxt').addClass('isShow');
              },
              // complete: ()=> {
              //   const elem = $('.number13 .num03');
              //   const elemTxt = elem.html();
              //   const targetTxt = elemTxt.slice(2, 4);
              //   const txtLength = targetTxt.length;// ターゲットの文字列の長さを取得
              //   const searchNum = elemTxt.indexOf(targetTxt);// 何文字目にあるか取得(0~)
              //   const firstStr = elemTxt.slice(0, searchNum);// これは
              //   const targetStr = elemTxt.slice(searchNum, searchNum+txtLength);// テスト
              //   // 結合
              //   elem.html(firstStr + '<span class="mini">' + targetStr + '</span>');
              // }
            });
            anime({
              targets: roundDateLogEl03Mini,
              innerHTML: [0, 6],
              duration: 1000,
              delay:500,
              round: 1, // Will round the animated value to 1 decimal
            });
          }
          
        }
      });
    }
  
    numbersAreaFunc();

    $(window).on('load scroll', function () {
      numbersAreaFunc();
    });
  }
}